// Source-of-truth content for Logan Hunter Group / Exit Strategy Experts

export const CONTACT = {
  phone: "575-420-3926",
  phoneOffice: "575-237-8822",
  phoneHref: "tel:+15754203926",
  email: "sb@loganhuntergroup.com",
  emailHref: "mailto:sb@loganhuntergroup.com",
  location: "Carlsbad, NM",
  serviceArea: "Serving clients nationwide",
  domains: ["loganhuntergroup.com", "exitstrategyexperts.org"],
};

export const COVEY = {
  line: "Begin with the end in mind.",
  attribution: "Stephen Covey",
};

export const SCOTT = {
  name: "Scott Bucher",
  title: "Strategic Business Advisor",
  subtitle: "Strategic Business Management & Financial Advisory",
  quote:
    "Successful exits don't happen by accident. They happen on purpose, the result of disciplined planning and preparation.",
  intro:
    "One advisor with the experience of a full team, carrying business owners from launch, growth, and funding all the way to a maximized exit.",
  bio: [
    "A Kansas City native raised in Scottsdale, Scott began his career in the late 1980s as a Seminar Coordinator with the Tom Hopkins Organization, mentored directly by Tom Hopkins, one of the most respected names in professional selling.",
    "A former UNM scholarship football athlete, he carried that same discipline into financial services beginning in 1992, choosing to build high-performing agencies rather than follow a traditional path.",
    "His expertise now spans business development, risk management, asset management, debt management, and commercial and residential lending, backed by a Master's in Strategic Management.",
    "Today, as a solo-preneur and owner of Logan Hunter Group, Scott specializes in business expansion, development, and exit-strategy planning: the work of an entire team, delivered by one trusted advisor.",
  ],
  facts: [
    { label: "Years of experience", value: "34+" },
    { label: "Mentored by", value: "Tom Hopkins" },
    { label: "In financial services since", value: "1992" },
    { label: "Discipline", value: "UNM Athlete" },
  ],
};

export const PILLARS = [
  {
    n: "01",
    title: "One advisor, one fee",
    body: "The work of eight-to-ten specialists: a valuator, a plan writer, a marketing strategist, a developer, a financial analyst, and more, all coordinated by a single advisor for a single fee.",
  },
  {
    n: "02",
    title: "Done-for-you & bank-ready",
    body: "Deliverables built to carry weight where it counts: in front of lenders, underwriters, the SBA, and buyers. Never templates; built around your actual numbers and story.",
  },
  {
    n: "03",
    title: "A compressed timeline",
    body: "Work that typically drags for a year or more, delivered in weeks to a few months: exit deliverables in 4–6 weeks, 8(a) filed in 2–3 months, a launch in 3.",
  },
  {
    n: "04",
    title: "Roughly 90% savings",
    body: "The same scope priced à la carte runs tens of thousands. The LHG / ESE engagement delivers it for a fraction, a recurring save-90%+ theme across every offer.",
  },
];

export const MARQUEE_ITEMS = [
  "10 Experts · 1 Fee",
  "Done-for-you & Bank-ready",
  "Delivered in Weeks, Not a Year",
  "Save ~90% vs. Hiring Separately",
  "From Start-Up to Exit",
  "Your First Day to Your Best Last Day",
];

// brand: 'lhg' (the journey) | 'ese' (the destination / flagship)
export const SERVICES = [
  {
    slug: "launch",
    brand: "lhg",
    code: "Launch",
    stage: "01 · Start-Up",
    eyebrow: "The Launch Engagement",
    title: "The New-Business",
    titleItalic: "Launch Engagement",
    tagline: "From idea to open, findable, and revenue-ready.",
    problem:
      "Starting is the hardest part. Between entity formation, tax registration, a real business plan, branding, a website, and getting found locally, most founders stall, juggling six specialists and guessing at the rest.",
    whoFor:
      "New founders and startups who need to go from idea to open, findable, and revenue-ready, without assembling a team they can't yet afford.",
    deliverables: [
      "Entity Formation & Structure: Articles of Organization, federal EIN, custom operating agreement",
      "Tax & Revenue Registration",
      "Business Plan & 3–5 Year Projections",
      "Brand Identity & Marketing",
      "Website & Digital Storefront",
      "Local Visibility & SEO",
      "12 Weekly Counseling Sessions",
    ],
    timeline: "A complete launch in 3 months",
    valueLine: "A full formation-to-first-customers system, coordinated by one advisor.",
    savings: "One fee, not six",
    reframe:
      "Open, findable, and revenue-ready in three months, how would that change your first year?",
  },
  {
    slug: "grow-expand",
    brand: "lhg",
    code: "Grow & Expand",
    stage: "02 · Growth",
    eyebrow: "Market Visibility & Growth",
    title: "Grow &",
    titleItalic: "Expand",
    tagline: "On the map, online, and in the market, running on autopilot in 30 days.",
    problem:
      "You're losing business to competitors who simply show up online when you don't. Being invisible isn't a marketing problem; it's a revenue problem.",
    whoFor:
      "Established small-business owners who are invisible online and want a marketing system that runs in about an hour a day.",
    deliverables: [
      "Professional Website (5–7 pages, mobile-ready)",
      "Two Social Media Platforms set up & launched",
      "Google Business Profile claimed & optimized",
      "Full Market Analysis",
      "SBA-Ready Business Plan",
      "3-Year Growth Plan & Financial Projections",
      "1-Hour Daily Marketing Action Plan",
      "HR Management Plan",
      "Operational Efficiency Plan",
      "Professional Business Valuation (delivered Day 180)",
    ],
    timeline: "90–120 day completion · valuation delivered Day 180",
    valueLine: "Ten specialists in one: comparable market value $39,000–$53,000.",
    savings: "Save 90–95%+",
    reframe:
      "Your Google reputation managed on autopilot, capturing 126+ local searches a month, how would that be?",
  },
  {
    slug: "sba-loan-prepackaging",
    brand: "lhg",
    code: "SBA Pre-Packaging",
    stage: "03 · Funding",
    eyebrow: "The Difference an Expert Makes",
    title: "SBA Loan",
    titleItalic: "Pre-Packaging",
    tagline: "Walk in confident. Walk out approved.",
    problem:
      "The DIY SBA experience means no independent valuation, a generic downloaded plan, months of back-and-forth, un-normalized financials, no growth strategy, and flying blind at the bank.",
    whoFor:
      "Owners seeking SBA financing to buy or grow a business who need to walk into the bank fully prepared.",
    deliverables: [
      "Independent four-method business valuation",
      "Bank-ready business plan built on your numbers",
      "Transaction managed start-to-close (10-week structured system)",
      "One advisor coordinating banker, CPA, attorney, buyer & seller",
      "Financials normalized and stress-tested (DSCR done correctly)",
      "Pro formas that pass SBA minimums",
      "A 3-year growth roadmap",
      "Bi-weekly coaching through approval",
    ],
    timeline: "A 10-week structured system, start to close",
    valueLine: "Comparable cost to hire separately: $32,000–$60,000.",
    savings: "Save 90%+",
    reframe:
      "An independent valuation and a lender-ready plan built on your numbers, how differently would that meeting go?",
  },
  {
    slug: "government-contracting",
    brand: "lhg",
    code: "Government Contracting",
    stage: "04 · Expansion",
    eyebrow: "SBA 8(a) Fast Track",
    title: "Government",
    titleItalic: "Contracting Prep",
    tagline: "Win federal contracts in a lane your competitors can't enter.",
    problem:
      "Federal contracting is a maze of paperwork most firms never finish, and without 8(a) certification, you're competing in the open market against everyone.",
    whoFor:
      "Firms pursuing government contracts who want a protected lane via SBA 8(a) certification: sole-source awards up to $4.5M and set-asides competitors can't touch.",
    deliverables: [
      "Federal-grade Capability Statement",
      "SAM.gov setup & NAICS alignment",
      "Feasibility analysis with realistic contract ceilings",
      "3–5 year SBA-aligned strategic business plan",
      "3–5 year financial projections",
      "A phased growth plan to 8(a) graduation",
      "Full SBA eligibility evidence package",
      "APEX Accelerator coordination",
    ],
    timeline: "Filed in 2–3 months",
    valueLine: "Comparable prep elsewhere: $25,000–$35,000, often a year or more.",
    savings: "Save ~90%",
    reframe:
      "A protected lane, mapped turn by turn, how would that reshape your pipeline?",
  },
  {
    slug: "risk-management",
    brand: "lhg",
    code: "Risk Management",
    stage: "05 · Protection",
    eyebrow: "Delivered via Zia Risk Management",
    title: "Risk",
    titleItalic: "Management",
    tagline: "Safeguard the value you're building at every stage.",
    problem:
      "A business is most exposed exactly when it's moving: launching, growing, borrowing, or preparing to sell. Value built without protection is value at risk.",
    whoFor:
      "Owners at any stage who want asset protection and risk mitigation woven through the entire journey, not bolted on after a loss.",
    deliverables: [
      "Asset protection strategy across every stage",
      "Risk assessment & mitigation planning",
      "Coverage aligned to launch, growth & lending phases",
      "Protection structured ahead of a sale",
      "Ongoing review as the business evolves",
    ],
    timeline: "Woven through the full LHG journey",
    valueLine: "The risk-management vehicle behind the Logan Hunter Group journey.",
    savings: "Protection by design",
    reframe:
      "Every milestone protected as you build it, what would that peace of mind be worth?",
  },
  {
    slug: "scale-to-seven-figures",
    brand: "ese",
    code: "Scale to Seven Figures",
    stage: "06 · On-ramp",
    eyebrow: "The Seven-Figure Engagement",
    title: "Scale to",
    titleItalic: "Seven Figures",
    tagline: "From \u201cstill running it\u201d to \u201cready to sell it.\u201d",
    problem:
      "A business that depends on the owner isn't an asset; it's a job. Scaling to seven figures means engineering income and building a business that runs without you.",
    whoFor:
      "Owners ready to scale who need to turn a system-run business into a sellable asset and capture full value at sale.",
    deliverables: [
      "Your Capability Statement",
      "Detailed Target-Market Analysis",
      "Custom Marketing Plan & Roadmap",
      "The Golden Moment & Six-Minute Sale system",
      "Building Your Team",
      "Your 7-Figure Income: engineered, not hoped-for",
      "Your Strategic Exit Strategy",
    ],
    timeline: "A seven-part advisory system",
    valueLine: "Built on the principles of The Golden Moment and The Six-Minute Sale.",
    savings: "The on-ramp to exit",
    reframe:
      "A business that runs itself and sells for its full worth, where would that put your next chapter?",
  },
  {
    slug: "exit-on-your-terms",
    brand: "ese",
    code: "Exit & Sell",
    stage: "07 · Exit",
    eyebrow: "The Flagship Destination",
    title: "Exit on",
    titleItalic: "Your Terms",
    tagline: "The final destination, where the whole journey leads.",
    problem:
      "Most owners sell once. Without a professional CIM, engineered deal structures, and a due-diligence defense, you negotiate from weakness, and leave real money on the table.",
    whoFor:
      "Owners planning to sell who want to maximize business value and protect proceeds through the transaction.",
    deliverables: [
      "Professional CIM (30–90 pp): your business's \u201cresume\u201d",
      "Four Engineered Deal Structures: asset, stock, seller-financing, earnout",
      "Negotiation Playbook & Tactics",
      "Due Diligence Defense Manual (90–150 pp)",
      "Complete Transaction Management System",
      "24-Month Post-Close Protection Protocols",
      "Professional CIM: Growth & Acquisition focused",
      "Sales Growth Plan: Revenue Acceleration Blueprint",
      "1-Hour-a-Day Marketing Plan",
    ],
    timeline: "Delivery in 4–6 weeks · up to one hour of weekly consultation throughout",
    valueLine: "Framed around three promises: Confidence · Protection · Maximization. Comparable value ~$35,000 if subcontracted individually.",
    savings: "About 90% less",
    reframe:
      "A maximized sale on your terms, with proceeds protected for 24 months after close, isn't that worth planning on purpose?",
    flagship: true,
  },
];

export const COMPANIES = [
  {
    key: "lhg",
    name: "Logan Hunter Group",
    role: "The Lead · Parent Brand",
    line: "The master strategic-advisory brand that carries an owner across the entire lifecycle: new-business start-ups, growth and expansion, government contracting, SBA loan pre-packaging, and risk management. The whole journey, from start-up to exit.",
  },
  {
    key: "ese",
    name: "Exit Strategy Experts",
    role: "The Destination · Flagship",
    line: "The flagship specialist brand for the final chapter: exit planning, growth-to-exit, and business sale. Given full billing, never minimized. Though it's the last chapter chronologically, it's often where the conversation begins.",
  },
  {
    key: "zia",
    name: "Zia Risk Management",
    role: "The Risk-Management Vehicle",
    line: "The vehicle that delivers the risk-management line within the LHG journey, safeguarding the value being built as a business launches, grows, borrows, or prepares to sell.",
  },
];

// Zia Risk Management standalone one-pager
export const ZIA = {
  eyebrow: "A Logan Hunter Group Company",
  title: "Zia Risk",
  titleItalic: "Management",
  tagline: "Protection, engineered into every stage of the journey.",
  problem:
    "A business is most exposed exactly when it's moving: launching, growing, borrowing, or preparing to sell. Value built without protection is value at risk, and most owners only discover the gap after a loss.",
  whoFor:
    "Owners at any stage who want asset protection and risk mitigation woven through the entire journey, not bolted on after something goes wrong.",
  deliverables: [
    "Comprehensive risk assessment across the whole operation",
    "Asset protection strategy and entity structuring review",
    "Coverage aligned to launch, growth, and lending phases",
    "Liability and continuity planning for key-person exposure",
    "Protection structured ahead of a sale to defend proceeds",
    "Ongoing review as the business evolves",
  ],
  timeline: "Woven through the full LHG journey, reviewed at every milestone",
  valueLine: "The dedicated vehicle that safeguards the value being built across every other engagement.",
  savings: "Protection by design",
  reframe:
    "Every milestone protected as you build it, what would that peace of mind be worth?",
};

// Real client testimonials
export const TESTIMONIALS = [
  {
    quote:
      "I've never had training this practical, personal, and strategic. Scott doesn't just teach theory; he hands you the templates, systems, and tools that actually work. My monthly production doubled within 90 days.",
    name: "Barbara R.",
    role: "Life Insurance Agent · Georgia",
  },
  {
    quote:
      "The exit strategy changed how I look at my business. It isn't about closing more anymore; it's about building something that runs without me. With Scott's mentorship, I onboarded five new loan officers this quarter alone.",
    name: "Chris G.",
    role: "Mortgage Brokerage · Arizona",
  },
  {
    quote:
      "Scott helped me build my business plan and financials in five days. We submitted on Wednesday and were approved the following Monday. Thank you, Scott.",
    name: "Alan J.",
    role: "Trucking and Transport · New Mexico",
  },
  {
    quote:
      "I started my firm on the side while juggling family and another job. Scott's approach didn't just make it doable; we built a pipeline that generates deals every week. Now I earn a full-time income on part-time hours. This gave me hope and freedom.",
    name: "Celeste M.",
    role: "Freelance Bookkeeper · Missouri",
  },
  {
    quote:
      "I needed help with marketing and never had the time; I'd disappear into social media and get nothing done. Scott's One Hour a Day Marketing Plan changed that. Now my marketing is done before 6:30 AM, and best of all, it works.",
    name: "David K.",
    role: "CPA · Louisiana",
  },
];

// Resources offers: 'request' = free copy emailed by Scott; 'demo' = live 15-min power brief
export const DOWNLOADS = [
  {
    key: "deliverables",
    type: "request",
    eyebrow: "FREE · BY REQUEST",
    headline: "What one fee actually replaces.",
    description:
      "See the real market cost of hiring each specialist separately, and what one fee replaces. Request a copy and Scott will email it to you.",
    title: "Deliverables Value Clarification",
  },
  {
    key: "golden",
    type: "demo",
    eyebrow: "LIVE POWER BRIEF · 15 MIN",
    headline: "The Golden Moment, walked through live.",
    description:
      "A free 15-minute live power brief over Google Meet or Zoom. See how to find the window when your business is worth the most, and build toward it on purpose.",
    title: "The Golden Moment Power Brief",
  },
  {
    key: "sixmin",
    type: "demo",
    eyebrow: "LIVE POWER BRIEF · 15 MIN",
    headline: "The Six-Minute Sale, walked through live.",
    description:
      "A free 15-minute live power brief over Google Meet or Zoom. Learn to tell your business story so clearly, and back it with numbers so credible, that a serious buyer is sold before the conversation ends.",
    title: "The Six-Minute Sale Power Brief",
  },
];

export const RESOURCES = [
  {
    key: "golden-moment",
    label: "The Concept",
    title: "The Golden",
    titleItalic: "Moment",
    body: "Every business has a golden moment: the window when its value, its systems, and the market align. The Golden Moment is about recognizing that window early and engineering toward it on purpose, so the sale happens at the peak rather than by accident.",
    points: [
      "Read the signals that reveal peak-value timing",
      "Build the systems that make a business sellable",
      "Plan backward from the exit, starting today",
    ],
  },
  {
    key: "six-minute-sale",
    label: "The Concept",
    title: "The Six-Minute",
    titleItalic: "Sale",
    body: "Buyers decide fast. The Six-Minute Sale is the discipline of telling your business's story so clearly, and backing it with such credible numbers, that a serious buyer understands the opportunity almost immediately, then spends the rest of due diligence confirming what they already believe.",
    points: [
      "Lead with the outcome, not the features",
      "Make the numbers effortless to trust",
      "Turn a professional CIM into a fast yes",
    ],
  },
];

export const LEAD_MAGNET = {
  title: "Deliverables Value Clarification",
  subtitle: "See the real market cost of hiring each specialist separately, and what one fee replaces.",
  file: "/downloads/deliverables-value-clarification.pdf",
};

export const CLOSING_CTA =
  "The question isn't whether you can afford this guidance; it's whether you can afford to proceed without it.";
